import { atom } from 'recoil';
import { ComsUser } from '@/models/comsUser';
import { Authority } from '@/constants';

interface AuthAtomType {
  isLoading: boolean;
  isSignedIn: boolean;
  userId: string;
  email: string;
  name: string;
  nameFromOauth: string;
  phoneFromOauth: string;
  authority: Authority;
  user: ComsUser | null;
}

export const authAtom = atom<AuthAtomType>({
  key: 'auth',
  default: {
    isLoading: true,
    isSignedIn: false,
    userId: '',
    email: '',
    name: '',
    nameFromOauth: '',
    phoneFromOauth: '',
    authority: Authority.UNKNOWN,
    user: null,
  },
});
